// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"cb2656c6","472":"77a26d9e","813":"236c4f00","827":"dda5bf49"}[chunkId] + ".chunk.css";
};